import { render, staticRenderFns } from "./product_haircolor.vue?vue&type=template&id=6ccf5443&scoped=true&"
import script from "./product_haircolor.vue?vue&type=script&lang=js&"
export * from "./product_haircolor.vue?vue&type=script&lang=js&"
import style0 from "./product_haircolor.vue?vue&type=style&index=0&id=6ccf5443&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf5443",
  null
  
)

export default component.exports